import { FunctionComponent as F, useEffect, useRef, useState } from "react";
import TextTooltipOpt from "../UI/Tooltip/TextTooltipOpt";
import Typography, { TypographyProps } from '@mui/material/Typography';



interface IProps
{
  text: string,
  typographyProps?: TypographyProps,
}

const TooltipIfTruncated: F<IProps> = (props: IProps) =>
{
  const typographyRef = useRef<HTMLSpanElement | null>(null);
  const isTruncated = (element: HTMLSpanElement) => element.offsetWidth < element.scrollWidth;
  const [truncated, setTruncated] = useState(false);

  useEffect(() =>
  {
    if(typographyRef.current)
      setTruncated(isTruncated(typographyRef.current))
    else
      setTruncated(false);
  }, [typographyRef.current && isTruncated(typographyRef.current)])

  return (
    <TextTooltipOpt showtooltip={truncated} lines={[props.text]} tooltipPlacement='right-end'>
      <Typography ref={typographyRef} noWrap {...props.typographyProps}>
        {props.text}
      </Typography>
    </TextTooltipOpt>);
}

export default TooltipIfTruncated;

